@if (state.isOpen() && state.current(); as item) {
  <section
    class="org-chart-import-card"
    [class.org-chart-import-card--ready]="state.isReady()"
    [class.org-chart-import-card--failed]="state.isFailed()"
    aria-live="polite"
    (mousedown)="$event.stopPropagation()"
    (wheel)="$event.stopPropagation()">
    <header class="org-chart-import-card__header">
      <i
        class="pi"
        [class.pi-search]="state.isRunning()"
        [class.pi-check-circle]="state.isReady()"
        [class.pi-exclamation-triangle]="state.isFailed()"></i>
      <span class="org-chart-import-card__title">{{ title() }}</span>
      @if (state.isRunning()) {
        <span class="org-chart-import-card__tag"
          >{{ currentStepNumber() }} de {{ totalSteps }}</span
        >
      }
    </header>

    <p class="org-chart-import-card__file" [title]="item.fileName">
      {{ item.fileName }} · enviado em {{ item.createdAt | vaultDateTime }}
    </p>

    @if (state.isFailed()) {
      <p class="org-chart-import-card__error">{{ failureMessage() }}</p>
      <div class="org-chart-import-card__actions">
        <app-button
          label="Fechar"
          theme="link"
          [disabled]="state.isDiscarding()"
          (sendButtonClick)="close()" />
        <app-button
          label="Tentar de novo"
          icon="pi pi-upload"
          [fitContent]="true"
          (sendButtonClick)="retry()" />
      </div>
    } @else {
      <ol class="org-chart-import-card__steps">
        @for (step of state.steps(); track step.label) {
          <li
            class="org-chart-import-card__step"
            [ngClass]="'org-chart-import-card__step--' + step.state">
            @switch (step.state) {
              @case ('done') {
                <i class="pi pi-check-circle"></i>
              }
              @case ('current') {
                <span class="org-chart-import-card__spinner">
                  <app-cog-loading-spinner [size]="18" />
                </span>
              }
              @default {
                <i class="pi pi-circle"></i>
              }
            }
            <span>{{ step.label }}</span>
          </li>
        }
      </ol>

      <div class="org-chart-import-card__progress">
        <div class="org-chart-import-card__progress-bar" [style.width.%]="progressPercent()"></div>
      </div>

      @if (state.isReady()) {
        <p class="org-chart-import-card__hint">
          A proposta está pronta. Nada foi gravado no grupo ainda: revise e escolha o que entra.
        </p>
        <div class="org-chart-import-card__actions">
          @if (state.canDiscard()) {
            <app-button
              label="Descartar"
              theme="link"
              [disabled]="state.isDiscarding()"
              (sendButtonClick)="cancelImport()" />
          } @else {
            <span></span>
          }
          <app-button
            label="Revisar importação"
            icon="pi pi-list-check"
            [fitContent]="true"
            (sendButtonClick)="openReview()" />
        </div>
      } @else {
        <p class="org-chart-import-card__hint">
          Você pode continuar mexendo no grupo ou sair da tela. Quando terminar, este cartão vira o
          botão <b>Revisar importação</b>.
        </p>
        @if (state.canDiscard()) {
          <div class="org-chart-import-card__actions">
            <app-button
              label="Cancelar importação"
              theme="link"
              [disabled]="state.isDiscarding()"
              (sendButtonClick)="cancelImport()" />
          </div>
        }
      }
    }
  </section>
}
